/* v8 ignore start */
import {LottieAssetModel} from "@/lib/lottie/assets/lottieAssetModel";
import {TIntBoolean} from "@/lib/lottie/helpers/intBoolean";

export class LottieFileAssetModel<T extends LottieFileAssetModel.IJson> extends LottieAssetModel<T> {}

export namespace LottieFileAssetModel {
  export interface IJson extends LottieAssetModel.IJson {
    /**
     * Path to the directory containing a file
     * @default ""
     */
    u?: string;

    /**
     * Filename or data url
     * @default ""
     */
    p: string;

    /**
     * Whether the file is embedded
     * @default 0
     */
    e?: TIntBoolean;
  }
}
/* v8 ignore stop */
